import { useQueryClient } from "@tanstack/react-query";

import { useCreateReportCommentMutation } from "@api/graphql/types-and-hooks";
import { invalidateReviewItems, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { notifyError } from "@components/notifications/notifications";

type CommentTarget = { fieldId: string; proposedValue?: string; baseValue?: string } | { parentId: string };

interface CreateCommentCallbacks {
  onCreated?: () => void;
  onSettled?: () => void;
}

export const useCreateComment = () => {
  const queryClient = useQueryClient();
  const { mutate } = useCreateReportCommentMutation({
    onSuccess: (data) => {
      if (settleReviewMutation(data?.createReportComment, { failure: "Failed to create comment" })) {
        invalidateReviewItems(queryClient);
      }
    },
    onError: () => notifyError("Error creating comment. Please try again."),
  });

  return (target: CommentTarget, body: string, callbacks?: CreateCommentCallbacks) => {
    const variables =
      "parentId" in target
        ? { parentId: target.parentId, body }
        : { fieldId: target.fieldId, body, proposedValue: target.proposedValue, baseValue: target.baseValue };
    mutate(variables, {
      onSuccess: (data) => {
        if (data?.createReportComment?.success) callbacks?.onCreated?.();
      },
      onSettled: () => callbacks?.onSettled?.(),
    });
  };
};
